import { ChevronDown, ChevronUp, Circle, Minus } from "lucide-react";
import AnglesUpIcon from "@/components/icons/angles-up-icon";
import { MOVEMENT, describeTipMovement } from "@/utils/tip-movement";

const ICON = "w-4 h-4 xxs:w-3 xxs:h-3";

/** Just the icon for a movement status (also used by the marker key). */
export function TipMovementIcon({ status, className = ICON }) {
  switch (status) {
    case MOVEMENT.UP:
      return <ChevronUp className={`${className} text-green-500`} aria-hidden="true" />;
    case MOVEMENT.DOWN:
      return <ChevronDown className={`${className} text-red-500`} aria-hidden="true" />;
    case MOVEMENT.NEW:
      return <AnglesUpIcon className={`${className} text-green-500`} aria-hidden="true" />;
    case MOVEMENT.DROPPED:
      return (
        <AnglesUpIcon
          className={`${className} text-red-500 rotate-180`}
          aria-hidden="true"
        />
      );
    case MOVEMENT.SAME:
      return <Circle className={`${className} text-gray-400`} aria-hidden="true" />;
    case MOVEMENT.SCRATCHED:
      return <Minus className={`${className} text-gray-400`} aria-hidden="true" />;
    default:
      return null;
  }
}

/**
 * The movement marker ("chevron") beside a tip. Always renders the fixed-width
 * cell so the silks line up across Late Mail, Race Day tips and Early Mail;
 * the cell is empty when there is no movement to show (e.g. a locked row).
 *
 * @param {{ movement?: { status: string, relation: string, comparedWith: string } | null }} props
 */
export default function TipMovementMarker({ movement = null }) {
  const label = describeTipMovement(movement);
  return (
    <div
      className="tip-item-delta-container flex items-center justify-center w-6 xxs:w-5 flex-shrink-0"
      data-movement={movement?.status || "none"}
      title={label || undefined}
    >
      <TipMovementIcon status={movement?.status} />
      {label && <span className="sr-only">{label}</span>}
    </div>
  );
}
